import Image from "next/image";
import { useTranslation } from "next-i18next";

const NumbersComponent = () => {
    const { t } = useTranslation();

    return (
        <div className="w-full mt-[3rem] bg-primary text-[white] overflow-hidden child:flex child:items-center child:justify-center pb-[5rem] pt-[3rem] px-[1rem] md:px-[15rem] relative">
            <div className="text-[2rem]">{t("home.numbers.title")}</div>
            <div className="text-center text-[white] !items-start">
                <p className="text-center w-[80%] mt-[1rem] text-[1.2rem]">
                    {t("home.numbers.subtitle")}
                </p>
            </div>
            <div className="w-full mt-[5rem] mb-[7rem] text-[0.8rem] md:text:[1rem]">
                <div className="flex flex-wrap flex-row items-center justify-center gap-[2rem] w-full child:flex child:items-center child:justify-center">
                    <div
                        data-aos="zoom-in"
                        data-aos-duration="700"
                        className=" flex flex-col gap-[1rem]"
                    >
                        <div className="bg-[white] text-primary w-[12rem] h-[6rem] rounded-full flex flex-col items-center justify-center">
                            <p className="text-[0.8rem]">
                                {t("home.numbers.moreThan")}
                            </p>
                            <p className="text-[2rem] font-bold">
                                {t("home.numbers.productCount")}
                            </p>
                        </div>
                        <p className="text-[2rem] text-[#00B8FF]">
                            {t("home.numbers.products")}
                        </p>
                    </div>
                    <div
                        data-aos="zoom-in"
                        data-aos-duration="600"
                        className=" flex flex-col gap-[1rem]"
                    >
                        <div className="bg-[white] text-primary w-[12rem] h-[6rem]  rounded-full flex flex-col items-center justify-center">
                            <p className="text-[0.8rem]">
                                {t("home.numbers.moreThan")}
                            </p>
                            <p className="text-[2rem] font-bold">
                                {t("home.numbers.storeCount")}
                            </p>
                        </div>
                        <p className="text-[2rem] text-[#00B8FF]">
                            {t("home.numbers.stores")}
                        </p>
                    </div>
                    <div
                        data-aos="zoom-in"
                        data-aos-duration="500"
                        className=" flex flex-col gap-[1rem]"
                    >
                        <div className="bg-[white] text-primary w-[12rem] h-[6rem] rounded-full flex flex-col items-center justify-center">
                            <p className="text-[0.8rem]">
                                {t("home.numbers.moreThan")}
                            </p>
                            <p className="text-[2rem] font-bold">
                                {t("home.numbers.userCount")}
                            </p>
                        </div>
                        <p className="text-[2rem] text-[#00B8FF]">
                            {t("home.numbers.users")}
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <Image
                    data-aos="fade-up"
                    src={"/icons/waveIco.svg"}
                    width={1000}
                    height={1000}
                    alt="explain"
                    className="w-full bottom-0 absolute left-0"
                />
            </div>
        </div>
    );
};

export default NumbersComponent;
